import { Pipe, PipeTransform } from '@angular/core';
import { environment as ENV } from '@environment';

@Pipe({
  name: 'ImageDimension',
  standalone: false
})
export class ImageDimensionPipe implements PipeTransform {

  private baseProxyImages: string = ENV.proxy_images;

  transform(src: string, dimension: string): string {
    return `${this.baseProxyImages}/${dimension}/${src}`;
  }
} 
